export default {
  "title": "سياسة الخصوصية لموقع DeMaxtore.com",
  "subtitle": "توضح سياسة الخصوصية هذه كيف تجمع Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.، المشغِّلة لعلامة DeMaxtore، البيانات الشخصية والتجارية وتعالجها.",
  "lastUpdated": "آخر تحديث: ٢٦ مايو ٢٠٢٦",
  "back": "← العودة إلى الصفحة الرئيسية",
  "sections": [
    {
      "title": "١. نبذة عن DeMaxtore",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore هي العلامة التجارية والمنصة الرقمية التي تديرها Demakstore Gıda İhracat San. ve Tic. Ltd. Şti."
        },
        {
          "type": "p",
          "text": "DeMaxtore منصة B2B تساعد المشترين الدوليين على توريد المنتجات من مصنعين أتراك موثقين، ومقارنة عروض الشحن، وإدارة عمليات التفتيش، وتتبع الشحنات من الاستلام في المصنع حتى التسليم في المستودع."
        },
        {
          "type": "p",
          "text": "قد تشمل خدماتنا، على سبيل المثال لا الحصر:"
        },
        {
          "type": "ul",
          "items": [
            "دليل الموردين وخدمات إدراج المصنعين",
            "أدوات استفسار المشترين والتواصل مع الموردين",
            "عمليات التوريد والمزايدة عبر CommodityBid",
            "خدمات مقارنة الشحن عبر FreightIQ",
            "تنسيق التفتيش",
            "تتبع الشحنات المباشر",
            "إدارة عمليات الاستيراد وخدمات الدعم ذات الصلة"
          ]
        }
      ]
    },
    {
      "title": "٢. البيانات الشخصية التي نجمعها",
      "blocks": [
        {
          "type": "p",
          "text": "قد نجمع البيانات الشخصية مباشرة من المستخدمين أو الشركات أو الموردين أو المشترين أو مقدمي الخدمات اللوجستية أو شركاء الأعمال الآخرين عند استخدام موقعنا أو خدماتنا."
        },
        {
          "type": "p",
          "text": "قد تشمل البيانات الشخصية التي نجمعها:"
        },
        {
          "type": "ul",
          "items": [
            "الاسم الكامل",
            "اسم الشركة",
            "المسمى الوظيفي أو القسم",
            "البريد الإلكتروني التجاري",
            "رقم الهاتف",
            "البلد والمدينة",
            "موقع الشركة الإلكتروني",
            "طلبات توريد المنتجات",
            "معلومات المورد أو المصنع",
            "معلومات الشحن والتسليم واللوجستيات",
            "تفاصيل طلبات التفتيش",
            "الرسائل والاستفسارات والنماذج وسجلات التواصل",
            "معلومات تسجيل الدخول للحساب، إن وجدت",
            "عنوان IP ونوع المتصفح ومعلومات الجهاز وبيانات استخدام الموقع"
          ]
        },
        {
          "type": "p",
          "text": "نعالج المعلومات عموماً في سياق B2B ولا نجمع عن قصد بيانات شخصية حساسة إلا إذا قدمها المستخدم طوعاً وكانت ضرورية لخدمة محددة."
        }
      ]
    },
    {
      "title": "٣. كيفية جمع البيانات الشخصية",
      "blocks": [
        {
          "type": "p",
          "text": "قد نجمع البيانات الشخصية عندما:"
        },
        {
          "type": "ul",
          "items": [
            "تزور www.demaxtore.com",
            "تملأ نموذج اتصال",
            "تقدم طلب توريد",
            "تنشئ حساب مشتري أو مورد أو تستخدمه",
            "تستخدم CommodityBid",
            "تستخدم FreightIQ",
            "تطلب مقارنة شحن",
            "تطلب خدمات تفتيش",
            "تطلب دعم تتبع الشحنات",
            "تتواصل معنا عبر البريد الإلكتروني أو الهاتف أو WhatsApp أو قنوات أخرى",
            "تشترك في التحديثات أو النشرات أو الاتصالات التجارية",
            "تتواصل مع ممثلي DeMaxtore"
          ]
        },
        {
          "type": "p",
          "text": "قد نتلقى أيضاً معلومات تجارية من موردين أو مصنعين أو شركاء لوجستيين أو شركاء تفتيش أو مصادر تجارية متاحة للجمهور حيث يسمح القانون بذلك."
        }
      ]
    },
    {
      "title": "٤. أغراض معالجة البيانات الشخصية",
      "blocks": [
        {
          "type": "p",
          "text": "نعالج البيانات الشخصية للأغراض التالية:"
        },
        {
          "type": "ul",
          "items": [
            "توفير الوصول إلى موقع وخدمات DeMaxtore",
            "إدارة استفسارات المشترين والموردين",
            "ربط المشترين بالموردين أو المصنعين المناسبين",
            "معالجة طلبات التوريد عبر CommodityBid",
            "مقارنة عروض الشحن عبر FreightIQ",
            "تنسيق خدمات التفتيش وتتبع الشحنات",
            "التواصل مع المستخدمين والمشترين والموردين وشركاء اللوجستيات",
            "تقديم دعم العملاء",
            "التحقق من معلومات الشركة أو المورد",
            "تحسين موقعنا وخدماتنا وتجربة المستخدم",
            "إرسال اتصالات تجارية أو متعلقة بالخدمة",
            "منع الاحتيال أو إساءة الاستخدام أو البريد العشوائي أو النشاط غير المصرح به",
            "الامتثال للالتزامات القانونية والتعاقدية والتنظيمية أو الضريبية",
            "حماية حقوق DeMaxtore وسلامتها وسمعتها ومصالحها المشروعة"
          ]
        }
      ]
    },
    {
      "title": "٥. الأساس القانوني للمعالجة",
      "blocks": [
        {
          "type": "p",
          "text": "حيثما ينطبق GDPR أو قوانين حماية بيانات مماثلة، نعالج البيانات الشخصية بناءً على واحد أو أكثر من الأسس التالية:"
        },
        {
          "type": "ul",
          "items": [
            "تنفيذ عقد: عندما تكون المعالجة ضرورية لتقديم خدماتنا",
            "مصلحة مشروعة: للتواصل B2B وتحسين الخدمة ومنع الاحتيال وتنسيق التوريد واللوجستيات وتطوير الأعمال",
            "الموافقة: حيث يمنح المستخدمون موافقة على التسويق أو ملفات تعريف الارتباط أو الاتصالات الاختيارية",
            "التزام قانوني: حيث تتطلب المعالجة قانوناً أو لائحة أو أمر محكمة أو طلب سلطة عامة"
          ]
        },
        {
          "type": "p",
          "text": "يجوز للمستخدمين سحب الموافقة في أي وقت عندما تستند المعالجة إلى الموافقة."
        }
      ]
    },
    {
      "title": "٦. مشاركة البيانات الشخصية",
      "blocks": [
        {
          "type": "p",
          "text": "لتقديم خدماتنا، قد نشارك البيانات الشخصية أو التجارية ذات الصلة مع:"
        },
        {
          "type": "ul",
          "items": [
            "موردين ومصنعين موثقين",
            "مشترين يقدمون طلبات توريد",
            "وكلاء شحن وشركاء لوجستيين",
            "مقدمي خدمات التفتيش",
            "مقدمي خدمات الدفع أو المحاسبة أو القانون أو الامتثال",
            "مقدمي البنية التحتية لتقنية المعلومات والاستضافة وCRM والبريد والتحليلات والسحابة",
            "مستشارين تجاريين أو ممثلين معتمدين لـ DeMaxtore",
            "سلطات عامة أو محاكم أو جهات تنظيمية عندما يقتضي القانون ذلك"
          ]
        },
        {
          "type": "p",
          "text": "على سبيل المثال، عند تقديم مشتري طلب توريد، قد تُشارك تفاصيل الاتصال التجاري وتفاصيل الطلب مع موردين أو شركاء خدمة معنيين لتسهيل عملية التوريد."
        },
        {
          "type": "p",
          "text": "لا نبيع البيانات الشخصية لأطراف ثالثة."
        }
      ]
    },
    {
      "title": "٧. دليل الموردين وملفات الشركات",
      "blocks": [
        {
          "type": "p",
          "text": "قد يعرض DeMaxtore معلومات متعلقة بالشركات في دليل الموردين أو واجهة المنصة، وقد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "اسم الشركة",
            "فئات المنتجات",
            "البلد أو المدينة",
            "وصف النشاط التجاري",
            "موقع الشركة الإلكتروني",
            "خيارات الاتصال أو الاستفسار",
            "حالة التحقق",
            "تفاصيل تجارية ذات صلة تقدمها الشركة"
          ]
        },
        {
          "type": "p",
          "text": "تتحمل الشركات مسؤولية ضمان أن المعلومات التي تقدمها دقيقة وقانونية ومحدّثة ولا تنتهك حقوق أي طرف ثالث."
        }
      ]
    },
    {
      "title": "٨. الرسائل ونماذج الاتصال والاستفسارات",
      "blocks": [
        {
          "type": "p",
          "text": "عند إرسال المستخدمين استفسارات أو رسائل أو طلبات توريد عبر DeMaxtore، قد يراجع فريق DeMaxtore محتوى هذه الاتصالات لأغراض تشغيلية ودعم وجودة وامتثال وإدارة الخدمة."
        },
        {
          "type": "p",
          "text": "قد تُشارك الرسائل أيضاً مع موردين أو مشترين أو مقدمي لوجستيات أو شركاء تفتيش أو أطراف أخرى مشاركة في الخدمة المطلوبة."
        },
        {
          "type": "p",
          "text": "يجب ألا يقدم المستخدمون محتوى غير قانوني أو مضللاً أو مسيئاً أو احتيالياً أو متعلقاً بالبريد العشوائي أو منتهكاً لحقوق الغير عبر موقعنا أو خدماتنا."
        }
      ]
    },
    {
      "title": "٩. بيانات CommodityBid",
      "blocks": [
        {
          "type": "p",
          "text": "عند استخدام CommodityBid، قد نعالج معلومات مثل:"
        },
        {
          "type": "ul",
          "items": [
            "طلبات توريد المشترين",
            "مواصفات المنتج",
            "الكمية والتعبئة وتوقعات التسليم",
            "السعر المستهدف أو تفاصيل المزايدة",
            "عروض الموردين",
            "معلومات الشركة والاتصال",
            "سجلات التواصل المتعلقة بعملية المزايدة"
          ]
        },
        {
          "type": "p",
          "text": "تُستخدم هذه البيانات لإدارة عمليات مزايدة B2B منظمة بين المشترين وموردين أو مصنعين موثقين."
        }
      ]
    },
    {
      "title": "١٠. بيانات FreightIQ والشحن",
      "blocks": [
        {
          "type": "p",
          "text": "عند استخدام FreightIQ أو مقارنة الشحن أو خدمات تتبع الشحنات، قد نعالج بيانات مثل:"
        },
        {
          "type": "ul",
          "items": [
            "تفاصيل الاستلام والتسليم",
            "نوع الشحنة",
            "معلومات المنتج أو البضاعة",
            "متطلبات الشحن",
            "عروض الوسطاء",
            "تحديثات التتبع",
            "معلومات تجارية متعلقة بالجمارك أو المستندات",
            "بيانات اتصال المشترين والموردين وشركاء اللوجستيات"
          ]
        },
        {
          "type": "p",
          "text": "تُستخدم هذه البيانات لمقارنة خيارات الشحن وتنسيق اللوجستيات ودعم رؤية الشحنة من الباب إلى الباب."
        }
      ]
    },
    {
      "title": "١١. بيانات خدمات التفتيش",
      "blocks": [
        {
          "type": "p",
          "text": "عند طلب خدمات التفتيش، قد نعالج:"
        },
        {
          "type": "ul",
          "items": [
            "تفاصيل المنتج",
            "معلومات المصنع أو المورد",
            "موقع التفتيش",
            "متطلبات التفتيش",
            "صور أو تقارير أو مستندات مراقبة الجودة",
            "بيانات اتصال الأطراف المعنية"
          ]
        },
        {
          "type": "p",
          "text": "تُستخدم هذه المعلومات لتنسيق خدمات التفتيش وإبلاغ نتائج التفتيش للأطراف التجارية المعنية."
        }
      ]
    },
    {
      "title": "١٢. WhatsApp Business وقنوات التواصل الأخرى",
      "blocks": [
        {
          "type": "p",
          "text": "قد تستخدم DeMaxtore WhatsApp Business أو البريد الإلكتروني أو الهاتف أو الرسائل القصيرة أو قنوات أخرى للتواصل مع المستخدمين والمشترين والموردين وشركاء الأعمال."
        },
        {
          "type": "p",
          "text": "إذا تواصلت معنا عبر WhatsApp أو أداة تواصل تابعة لطرف ثالث، فقد يخضع تواصلك أيضاً لسياسة خصوصية ذلك المزود."
        },
        {
          "type": "p",
          "text": "قد نحتفظ بسجلات التواصل لأغراض تجارية أو دعم أو قانونية أو جودة الخدمة ما لم يُطلب الحذف ولا ينطبق التزام قانوني بالاحتفاظ."
        }
      ]
    },
    {
      "title": "١٣. ملفات تعريف الارتباط والتقنيات المماثلة",
      "blocks": [
        {
          "type": "p",
          "text": "قد تستخدم DeMaxtore ملفات تعريف الارتباط وتقنيات مماثلة من أجل:"
        },
        {
          "type": "ul",
          "items": [
            "ضمان عمل الموقع",
            "تحسين تجربة المستخدم",
            "تحليل حركة الموقع",
            "تذكر تفضيلات المستخدم",
            "دعم الأمان ومنع الاحتيال",
            "قياس أداء التسويق"
          ]
        },
        {
          "type": "p",
          "text": "يمكن للمستخدمين إدارة ملفات تعريف الارتباط أو تعطيلها عبر إعدادات المتصفح. قد لا تعمل بعض ميزات الموقع بشكل صحيح إذا عُطّلت ملفات تعريف الارتباط."
        }
      ]
    },
    {
      "title": "١٤. الاتصالات التسويقية",
      "blocks": [
        {
          "type": "p",
          "text": "قد نتواصل مع المستخدمين وممثلي الشركات عبر البريد الإلكتروني أو الهاتف أو WhatsApp أو قنوات أخرى لأغراض متعلقة بالخدمة أو تجارية حيث يسمح القانون بذلك."
        },
        {
          "type": "p",
          "text": "يجوز للمستخدمين إلغاء الاشتراك في الاتصالات التسويقية في أي وقت بالتواصل معنا أو باستخدام خيار إلغاء الاشتراك حيثما كان متاحاً."
        },
        {
          "type": "p",
          "text": "حتى بعد إلغاء الاشتراك، قد نرسل اتصالات متعلقة بالخدمة أو المعاملات أو القانون أو الأمان عند الضرورة."
        }
      ]
    },
    {
      "title": "١٥. النقل الدولي للبيانات",
      "blocks": [
        {
          "type": "p",
          "text": "لأن DeMaxtore تعمل في بيئة تجارة B2B دولية، قد تُنقل البيانات الشخصية إلى دول خارج بلد إقامة المستخدم أو يُمكن الوصول إليها منها."
        },
        {
          "type": "p",
          "text": "حيث يقتضي القانون المعمول به، نتخذ ضمانات مناسبة لحماية البيانات الشخصية أثناء النقل الدولي، بما في ذلك تدابير تعاقدية وتقنية وتنظيمية."
        }
      ]
    },
    {
      "title": "١٦. الاحتفاظ بالبيانات",
      "blocks": [
        {
          "type": "p",
          "text": "نحتفظ بالبيانات الشخصية فقط للمدة اللازمة للأغراض الموضحة في سياسة الخصوصية هذه، بما في ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "تقديم الخدمات",
            "إدارة علاقات الأعمال",
            "معالجة التوريد واللوجستيات والمزايدة والتفتيش",
            "الامتثال للالتزامات القانونية والضريبية",
            "حل النزاعات",
            "منع الاحتيال أو إساءة الاستخدام",
            "الاحتفاظ بالسجلات التجارية"
          ]
        },
        {
          "type": "p",
          "text": "عندما لا تعود البيانات الشخصية مطلوبة، نحذفها أو نجهلها أو نؤرشفها بشكل آمن وفقاً للقوانين المعمول بها وممارسات الاحتفاظ الداخلية."
        }
      ]
    },
    {
      "title": "١٧. أمن البيانات",
      "blocks": [
        {
          "type": "p",
          "text": "نتخذ تدابير تقنية وتنظيمية معقولة لحماية البيانات الشخصية من:"
        },
        {
          "type": "ul",
          "items": [
            "الوصول غير المصرح به",
            "الفقد العرضي",
            "إساءة الاستخدام",
            "التعديل",
            "الإفصاح",
            "الإتلاف",
            "حوادث الأمن"
          ]
        },
        {
          "type": "p",
          "text": "ومع ذلك، لا يمكن ضمان أن أي نظام عبر الإنترنت آمن بالكامل. يتحمل المستخدمون مسؤولية الحفاظ على سرية بيانات تسجيل الدخول وإبلاغنا فوراً عند الوصول غير المصرح به أو الاشتباه في مشكلة أمنية."
        }
      ]
    },
    {
      "title": "١٨. حقوق المستخدم",
      "blocks": [
        {
          "type": "p",
          "text": "بحسب قوانين حماية البيانات المعمول بها، قد يكون للمستخدمين الحق في:"
        },
        {
          "type": "ul",
          "items": [
            "الوصول إلى بياناتهم الشخصية",
            "طلب تصحيح البيانات غير الدقيقة",
            "طلب حذف البيانات الشخصية",
            "الاعتراض على أنشطة معالجة معينة",
            "تقييد المعالجة",
            "سحب الموافقة",
            "طلب نقل البيانات",
            "تقديم شكوى إلى سلطة حماية بيانات مختصة"
          ]
        },
        {
          "type": "p",
          "text": "لممارسة هذه الحقوق، يمكن للمستخدمين التواصل مع DeMaxtore باستخدام بيانات الاتصال أدناه."
        }
      ]
    },
    {
      "title": "١٩. مواقع وخدمات الأطراف الثالثة",
      "blocks": [
        {
          "type": "p",
          "text": "قد يحتوي موقعنا على روابط لمواقع أو منصات أو مقدمي لوجستيات أو موردين أو مصنعين أو مقدمي خدمات تابعين لأطراف ثالثة."
        },
        {
          "type": "p",
          "text": "لا تتحمل DeMaxtore مسؤولية ممارسات الخصوصية أو المحتوى أو الأمان أو السياسات لمواقع أو خدمات الأطراف الثالثة. يجب على المستخدمين مراجعة سياسات الخصوصية لتلك الأطراف قبل مشاركة البيانات الشخصية."
        }
      ]
    },
    {
      "title": "٢٠. خصوصية الأطفال",
      "blocks": [
        {
          "type": "p",
          "text": "خدمات DeMaxtore مخصصة لمستخدمي الأعمال وليست موجهة للأطفال. لا نجمع عن قصد بيانات شخصية من أشخاص دون سن ١٨ عاماً."
        },
        {
          "type": "p",
          "text": "إذا علمنا أننا جمعنا بيانات شخصية من طفل دون تفويض مناسب، سنتخذ خطوات معقولة لحذف تلك البيانات."
        }
      ]
    },
    {
      "title": "٢١. تغييرات سياسة الخصوصية هذه",
      "blocks": [
        {
          "type": "p",
          "text": "قد تحدّث DeMaxtore سياسة الخصوصية هذه من وقت لآخر لتعكس تغييرات في خدماتنا أو المتطلبات القانونية أو العمليات التجارية أو ممارسات معالجة البيانات."
        },
        {
          "type": "p",
          "text": "سيُنشر الإصدار المحدّث على www.demaxtore.com مع تاريخ «آخر تحديث» المنقح. يعني الاستمرار في استخدام موقعنا أو خدماتنا بعد نشر التغييرات أن المستخدمين يقرّون بسياسة الخصوصية المحدّثة."
        }
      ]
    },
    {
      "title": "٢٢. الاتصال",
      "blocks": [
        {
          "type": "p",
          "text": "للأسئلة أو الطلبات أو الشكاوى المتعلقة بسياسة الخصوصية هذه أو بمعالجة البيانات الشخصية، يرجى التواصل معنا:"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "العلامة التشغيلية: DeMaxtore",
            "الموقع: www.demaxtore.com",
            "البريد الإلكتروني: support@demaxtore.com",
            "بريد إلكتروني بديل: demaxtore@demaxtore.com"
          ]
        }
      ]
    }
  ]
};
